export default (state, action) => {
  const { payload } = action;
  return {
    ...state,
    productMap: payload,
  };
};
